var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.940755 6.99608C0.940755 6.48762 1.36328 6.07226 1.86458 6.07226H6.07552V1.86132C6.07552 1.36002 6.49089 0.93749 6.99935 0.93749C7.50781 0.93749 7.92318 1.36002 7.92318 1.86132V6.07226H12.1341C12.6426 6.07226 13.0579 6.48762 13.0579 6.99608C13.0579 7.50455 12.6426 7.91991 12.1341 7.91991H7.92318V12.1308C7.92318 12.6393 7.50781 13.0547 6.99935 13.0547C6.49089 13.0547 6.07552 12.6393 6.07552 12.1308V7.91991H1.86458C1.36328 7.91991 0.940755 7.50455 0.940755 6.99608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f6b6a9716df0dd8a867e52c25dfb5ebf.svg";
export { ForwardRef as ReactComponent };